import { combineReducers } from "redux"
import digitalLibraryReducer from "./DigitalLibrary"
import pypReducer from "./PYP"
import userReducer from "./User"
import applicationReducer from "./Application"
import spouseApplicationReducer from "./SpouseApplication"
import formularyReducer from "./Formulary"
import workshopReducer from "./Workshop"

export default combineReducers({
  digitalLibrary: digitalLibraryReducer,
  pyp: pypReducer,
  // TODO: This might need to be broken up into it's constiuent reducers
  ...userReducer,
  application: applicationReducer,
  spouseApplication: spouseApplicationReducer,
  formulary: formularyReducer,
  workshop: workshopReducer
})
